module.exports = __webpack_public_path__ + "static/dedicated-support-c37af456fc3b0bba10e0e04b4ec2d455.png";